import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AolDataItem } from '../../../types/ViewModel/AolItem';
import { UpdateInfoWrapper } from './AolMain.style';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';

type Props = {
    aolDataItem: AolDataItem;
};

const AolUpdateInfoComponent: React.FC<Props> = (props) => {
    return (
        <UpdateInfoWrapper>
            {props.aolDataItem && (
                <>
                    {props.aolDataItem?.noonReport?.metadata.lastUpdatedUtc && (
                        <>
                            <h4>Last updated</h4>
                            <div>
                                <FontAwesomeIcon
                                    className="clock-icon"
                                    icon="clock"
                                    title={'Last update ' + prettifyDateTimeHHmm(props.aolDataItem?.noonReport?.metadata.lastUpdatedUtc)}
                                />
                                <span className="time-info">{prettifyDateTimeHHmm(props.aolDataItem?.noonReport?.metadata.lastUpdatedUtc)}</span>
                            </div>
                            <div>
                                <FontAwesomeIcon
                                    className="profile-icon"
                                    icon="user"
                                    title={'Last update by ' + props.aolDataItem?.noonReport?.metadata.lastUpdatedBy}
                                />
                                <span className="user-info">{props.aolDataItem?.noonReport?.metadata.lastUpdatedBy}</span>
                            </div>
                        </>
                    )}

                    {props.aolDataItem?.noonReport?.metadata.aolCompletedUtc && !props.aolDataItem?.noonReport?.metadata.aolApprovedUtc && (
                        <>
                            <h4>Completed</h4>
                            <div>
                                <FontAwesomeIcon
                                    className="clock-icon"
                                    icon="clock"
                                    title={'Order created ' + prettifyDateTimeHHmm(props.aolDataItem?.noonReport?.metadata.aolCompletedUtc)}
                                />
                                <span className="time-info">{prettifyDateTimeHHmm(props.aolDataItem?.noonReport?.metadata.aolCompletedUtc)}</span>
                            </div>
                            <div>
                                <FontAwesomeIcon className="profile-icon" icon="user" title={'Order created by '} />
                                <span className="user-info">{props.aolDataItem?.noonReport?.metadata.aolCompletedBy}</span>
                            </div>
                        </>
                    )}
                    {props.aolDataItem?.noonReport?.metadata.aolApprovedUtc && (
                        <>
                            <h4>Approved</h4>
                            <div>
                                <FontAwesomeIcon
                                    className="clock-icon"
                                    icon="clock"
                                    title={'Order created ' + prettifyDateTimeHHmm(props.aolDataItem?.noonReport?.metadata.aolApprovedUtc)}
                                />
                                <span className="time-info">{prettifyDateTimeHHmm(props.aolDataItem?.noonReport?.metadata.aolApprovedUtc)}</span>
                            </div>
                            <div>
                                <FontAwesomeIcon className="profile-icon" icon="user" title={'Order created by '} />
                                <span className="user-info">{props.aolDataItem?.noonReport?.metadata.aolApprovedBy}</span>
                            </div>
                        </>
                    )}
                </>
            )}
        </UpdateInfoWrapper>
    );
};

export default AolUpdateInfoComponent;
